import { render, staticRenderFns } from "./VetBorrower.vue?vue&type=template&id=1c7c5abe&"
import script from "./VetBorrower.vue?vue&type=script&lang=js&"
export * from "./VetBorrower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports